import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import UploadGrid from 'pages/uploadPage/components/uploadGrid';
import {
  TableLinksHelper,
  createEmptyRow,
} from 'entities/table/model/tableLinksHelper';
import { v4 as uuid } from 'uuid';
import CreateTableController from 'widgets/tables/createTableController';
import TableViewController from 'widgets/tables/tableViewController';
import { SxProps } from '@mui/material';
import { InitialPlacement } from 'entities/types';

export default observer(function UploadTable({
  isVisible,
  initialSectionId,
  initialFolderId,
  initialName,
}: {
  isVisible: boolean;
} & InitialPlacement) {
  const [tableHelper, setTableHelper] = useState(
    () => new TableLinksHelper({ links: [createEmptyRow(uuid())] })
  );
  const gridSx: SxProps = isVisible
    ? {
        'columnGap': 0,
        'gridTemplateAreas': "'left right'",
        '& > :nth-of-type(1)': {
          gridArea: 'left',
        },
        '& > :nth-of-type(2)': {
          gridArea: 'right',
        },
      }
    : {
        visibility: 'hidden',
        minHeight: 0,
        maxHeight: 0,
        height: 0,
        overflow: 'hidden',
      };

  return (
    <UploadGrid sx={gridSx} isAutoHeight>
      <TableViewController tableHelper={tableHelper}></TableViewController>

      <CreateTableController
        tableHelper={tableHelper}
        handleCancel={() =>
          setTableHelper(
            new TableLinksHelper({ links: [createEmptyRow(uuid())] })
          )
        }
        initialSectionId={initialSectionId}
        initialFolderId={initialFolderId}
        initialName={initialName}
      ></CreateTableController>
    </UploadGrid>
  );
});
